/* COPPERTIST.WU popup coordination. Preview-only; no app/cart/customer writes. */
(() => {
  'use strict';
  if (window.CWOverlayCoordinator) return;
  const root = document.documentElement;
  const groups = ['joy', 'chat', 'cart', 'offers', 'native-cart'];
  const selectors = 'joy-loyalty-widget, shopify-chat, [ymq-cart-app-slid-id="ymq-cart-app"], .popup-overlay, cart-drawer';
  let stack = [];
  let queued = false;
  const shown = element => {
    if (!element || element.hidden) return false;
    const style = getComputedStyle(element);
    return style.display !== 'none' && style.visibility !== 'hidden';
  };
  const any = selector => Array.from(document.querySelectorAll(selector)).some(shown);
  function sync() {
    queued = false;
    const active = {
      joy: any('joy-loyalty-widget[open]'),
      chat: any('shopify-chat[open]'),
      cart: root.classList.contains('ymq-cart-app-slid-locked') ||
        any('[ymq-cart-app-slid-id="ymq-cart-app"].opened'),
      offers: any('.popup-overlay'),
      'native-cart': any('cart-drawer.active')
    };
    // Keep every open popup accounted for. Closing one must not restore icons
    // while another popup is still open. Most recently opened group is on top.
    stack = stack.filter(group => active[group]);
    groups.forEach(group => { if (active[group] && !stack.includes(group)) stack.push(group); });
    const value = stack.join(' ');
    if (value && root.getAttribute('data-cw-overlay-open') !== value) root.setAttribute('data-cw-overlay-open', value);
    if (!value && root.hasAttribute('data-cw-overlay-open')) root.removeAttribute('data-cw-overlay-open');
    groups.forEach(group => {
      const index = stack.indexOf(group);
      const layer = String(index < 0 ? (['joy', 'chat'].includes(group) ? 1000 : 2147483100) : 2147483200 + index * 10);
      const key = `--cw-${group}-layer`;
      if (root.style.getPropertyValue(key) !== layer) root.style.setProperty(key, layer);
    });
  }
  function schedule() {
    if (queued) return;
    queued = true;
    // MutationObserver and this microtask finish before paint: no visible
    // launcher flash between an app opening and the coordinated state update.
    queueMicrotask(sync);
  }
  function relevantNode(node) {
    return node.nodeType === 1 && (node.matches(selectors) || node.querySelector(selectors));
  }
  const observer = new MutationObserver(records => {
    if (records.some(record => record.type === 'childList'
      ? [...record.addedNodes, ...record.removedNodes].some(relevantNode)
      : (record.target === root && record.attributeName === 'class') || record.target.matches(selectors))) schedule();
  });
  observer.observe(root, {subtree:true, childList:true, attributes:true,
    attributeFilter:['open','class','style','hidden','aria-hidden']});
  window.addEventListener('pageshow', schedule);
  document.addEventListener('joy-widget-toggle', schedule);
  document.addEventListener('shopify:section:load', schedule);
  window.CWOverlayCoordinator = Object.freeze({version:'2026-10-22.1',
    getState:() => ({open:stack.slice(), top:stack.at(-1) || null})});
  sync();
})();
